import { GenIcon } from '../helpers/IconBase.es.js';

const HeadphoneOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.10969 2C5.82201 2 3.15654 4.66548 3.15654 7.95315V10.6102C2.43563 11.4495 2 12.541 2 13.7342C2 15.4741 2.92607 16.9975 4.31223 17.8384V18.7061C4.31223 20.7172 5.9417 22.3467 7.95286 22.3467H13.7341C14.1484 22.3467 14.4841 22.0109 14.4841 21.5967C14.4841 21.1825 14.1484 20.8467 13.7341 20.8467H7.95286C6.77012 20.8467 5.81223 19.8888 5.81223 18.7061V18.43C6.13004 18.4963 6.45939 18.5311 6.7969 18.5311H7.95315C8.68666 18.5311 9.28128 17.9365 9.28128 17.203V10.2655C9.28128 9.53197 8.68666 8.93735 7.95315 8.93735H6.7969C6.02771 8.93735 5.30084 9.11835 4.65654 9.44009V7.95315C4.65654 5.4939 6.65044 3.5 9.10969 3.5H14.891C17.3502 3.5 19.3441 5.4939 19.3441 7.95315V9.44007C18.6998 9.11835 17.973 8.93735 17.2038 8.93735H16.0475C15.314 8.93735 14.7194 9.53197 14.7194 10.2655V17.203C14.7194 17.9365 15.314 18.5311 16.0475 18.5311H17.2038C19.8532 18.5311 22.0007 16.3837 22.0007 13.7342C22.0007 12.5409 21.5651 11.4495 20.8441 10.6102V7.95315C20.8441 4.66548 18.1786 2 14.891 2H9.10969ZM3.5 13.7342C3.5 11.9133 4.9759 10.4374 6.7969 10.4374H7.78128V17.0311H6.7969C4.9759 17.0311 3.5 15.5552 3.5 13.7342ZM16.2194 17.0311H17.2038C19.0248 17.0311 20.5007 15.5552 20.5007 13.7342C20.5007 11.9133 19.0248 10.4374 17.2038 10.4374H16.2194V17.0311Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { HeadphoneOutlined };
